import React from "react";

import {
  Box,
  // Stack,
} from '@chakra-ui/react';
// import PFHeading from "../PFHeading/PFHeading";
// import PFButton from "../PFButton/PFButton";
// import PFParagraph from "../PFParagraph/PFParagraph";
// import PFIconButton from "../PFIconButton/PFIconButton";
// import { FiAirplay } from "react-icons/fi";
// type PFAbilityCardProps = {
//   children: Object;
// };

export default function PFAbilityCard() {
  return (
    <Box></Box>
    // <Box bg="fondo" d="flex" flexDirection="column" justifyContent="center" minW="100vw" m="0" p="0" pt={["64px",
    //   "80px"]} pb={["32px",
    //     "64px"]} alignItems="center" >
    //   <PFHeading variant="h3" text="Skills" color="primario" />
    //   <Stack direction={{ sm: 'column', md: 'column', lg: 'row' }} justifyContent="center" gap='24px' py="90px">
    //     <Box h="308px" bg='rellenos' p="24px">
    //       <PFIconButton stylesProps={{
    //         background: "rellenos", color: "#59EBFF", marginBottom: "15px"

    //       }} hover={{ background: "rellenos", color: "blanco" }} icon={<FiAirplay />} ariaLabel="insta button" />
    //       <PFHeading color="blanco" variant="h3" text="Singer" stylesProps={{ marginBottom: "15px", textAlign: "left" }} />
    //       <PFParagraph color="blanco" variant="body1" text="This is wear you would talk about what kind of projects you do lol" stylesProps={{ textAlign: "left" }} />
    //     </Box>

    //     <Box w="354px" h="308px" bg='rellenos' p="24px">
    //       <PFIconButton stylesProps={{
    //         background: "rellenos", color: "primario", marginBottom: "15px"

    //       }} hover={{ background: "rellenos", color: "blanco" }} icon={<FiAirplay />} ariaLabel="insta button" />
    //       <PFHeading color="blanco" variant="h3" text="Songwriter" stylesProps={{ marginBottom: "15px", textAlign: "left" }} />
    //       <PFParagraph color="blanco" variant="body1" text="essentially this would be the skills section of your resume/portfolio" stylesProps={{ textAlign: "left" }} />
    //     </Box>
    //     <Box w="354px" h="308px" bg='rellenos' p="24px">
    //       <PFIconButton stylesProps={{
    //         background: "rellenos", color: "#59EBFF", marginBottom: "15px"

    //       }} hover={{ background: "rellenos", color: "blanco" }} icon={<FiAirplay />} ariaLabel="insta button" />
    //       <PFHeading color="blanco" variant="h3" text="DJ" stylesProps={{ marginBottom: "15px", textAlign: "left" }} />
    //       <PFParagraph color="blanco" variant="body1" text="tell people how cool you are and stuff" stylesProps={{ textAlign: "left" }} />
    //     </Box>
    //   </Stack>
    //   <PFButton variant="solid" size="size7" hover={{ bg: "linear-gradient(270deg, #1bd760 10.81%, #59EBFF 100%)" }}
    //   ><PFParagraph variant="boton" text="See more" />  </PFButton>
    // </Box >
  );
}
